<template>
    <div class="group">
        <div class="page-group-title"><span>绑定信息</span></div>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="bUser" label="绑定B类:">
                    <el-select 
                        v-model="formData.bUser" 
                        filterable 
                        remote
                        multiple
                        placeholder="请选择B类用户"
                        :remote-method="searchUser"
                        :loading="userLoading"
                        @change="changeBuser"
                        size="medium"
                        value-key="id">
                        <el-option
                            v-for="item in userList"
                            :key="item.id"
                            :label="`[${$userType.get(item.userType)}]${item.name}`"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="settlementsVO" label="结款方:">
                    <el-select 
                        v-model="formData.settlementsVO" 
                        filterable 
                        remote
						multiple
						:multiple-limit=1
                        placeholder="请选择结款方"
                        size="medium"
                        :remote-method="searchUser2"
                        :loading="userLoading"
                        @change="selectSettlements"
                        value-key="id">
                        <el-option
                            v-for="item in userList2"
                            :key="item.id"
                            :label="`${item.name}`"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
  <el-row :gutter="30">
   <el-col :xs="24" :sm="12" :xl="8">
    <el-form-item prop="balanceType" label="结算方式:">
     <el-select v-model="formData.balanceType" size="medium" :disabled="id!=''">
      <el-option :value="1" label="自营 - 预付款"></el-option>
      <el-option :value="2" label="代销 - 后付款"></el-option>
     </el-select>
    </el-form-item>    
   </el-col>
   <el-col :xs="24" :sm="12" :xl="8">
    <el-form-item prop="haveWhiteList" label="销售范围:" :rules='[{required: true, message: "请选择销售范围"}]'>
     <el-select v-model="formData.haveWhiteList" size="medium">
      <el-option :value="0" label="全平台用户"></el-option>
      <el-option :value="1" label="白名单用户"></el-option>
     </el-select>
    </el-form-item>    
   </el-col>
  </el-row>  
  <el-row :gutter="30">   
   <el-col :xs="24" :sm="12" :xl="8" v-if="formData.relevanceContracts && formData.relevanceContracts!='' && id">
    <el-form-item prop="relevanceContracts" label="关联合约:">
        <el-input v-model="formData.relevanceContracts[0].name"  size="medium" disabled></el-input>
    </el-form-item>
   </el-col>
  </el-row>  
        <el-row :gutter="30">
            <el-col :xs="24" :xl="16">
                <el-form-item prop="activities">
                    <template v-if="formData.categoryId === 9 ">						
						<span slot="label">订单入口绑定演出: <small class="from-tip"><span class="el-icon-warning"></span> 绑定演出的订单详情会在商品销售时间段内展示购买入口</small></span>
					</template>
					<template v-else>
						<span slot="label">现场自取点: <small class="from-tip"><span class="el-icon-warning"></span> 通过ID查询并绑定相关演出</small></span>
					</template>					
                    <el-input v-model="activityParams.activityId" class="input-with-select" :placeholder="activityParams.type == 1 ? '请输入演出ID' : '请输入巡演ID'" size="medium">
                        <el-select
                            v-model="activityParams.type"
                            slot="prepend"
                            placeholder="请选择"
                        >
                            <el-option label="绑定演出" :value="1"></el-option>
                            <el-option label="绑定巡演" :value="2" :disabled="formData.categoryId === 9 "></el-option>
                        </el-select>
                        <el-button slot="append" icon="el-icon-circle-plus" @click="searchEvent">添加</el-button>
                    </el-input>
                    <el-table
                        :data="formData.activities"
                        border
                        style="width: 100%"
                        size="small"
                        class="MT10"
                    >
                        <el-table-column prop="id" label="演出ID"></el-table-column>
                        <el-table-column prop="name" label="演出名称"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="80">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    icon="el-icon-delete"
                                    @click="delActivity(scope.row)"
                                    >删除</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import {fetchUser} from '@/assets/js/commonApi';
import {downloadFileTmp,uploadFileTmp} from '@/assets/js/commonApi.js';
export default {
    props:{
        formData:{
            type: Object,
            default: null
        },
		  id: {
			type: [Number, String],
			default: null,
		  }
    },
    data(){
        return{
            userList:[],
            userList2:[],			
            userLoading: false,
            activityParams:{
                activityId:'',
                type:1
            },
           dataLoading:false,
		   downLoading:false,
		   fileList:[],
		   uploadLoading:false,
		   btnLoading:false,
		   canSubmit:true,
		   // 
		}
    },
    mounted(){
        this.userList = this.formData.bUser;
        this.userList2 = this.formData.settlementsVO || [];
  
    },
    methods:{
        // 搜索用户
        async searchUser(query){
            if(query !== ""){
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue:query,
                    userType:-1,
                }).finally(() => {
                    this.userLoading = false;
                });
                
                const { state, result } = res.data;
                
                if (state == 1 && result) {
                    this.userList = result;
                }
            }
        },
        async searchUser2(query){
            if(query !== ""){
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue:query,
                    userType:-1,
                }).finally(() => {
                    this.userLoading = false;
                });
                
                const { state, result } = res.data;
                
                if (state == 1 && result) {
                    this.userList2 = result;
                }
            }
        },
        //绑定B类
        changeBuser(value){
            // this.formData.organizeres = value.filter( v => v.userType == 5);
            // this.formData.performeres = value.filter( v => v.userType == 2);
            // this.formData.sites = value.filter( v => v.userType == 3);
            // // if(!value || value.length < 1 || !value.find( v => v == this.formData.settlementsVO )){
            //     this.formData.settlementsVO = null;
            //     this.formData.settlements = [];
            // }
        },
        //绑定结款方
        selectSettlements(value){
            this.formData.settlements = [{...value}];
        },
        //搜索演出事件
        searchEvent() {
			
            if (this.activityParams.activityId !== "") {
                this.dataLoading = true;
                this.$request({
                    url: "/shop_good/activity",
                    params: this.activityParams,
                    method: "post",
                })
                    .then((res) => {
                        const { state, result, msg } = res.data;
                        if (state == 1 && result && result.length > 0) {
                            result.map( item => {
                                const _obj = this.formData.activities.find(v => v.id == item.id && v.name == item.name);
                                if(!_obj){
                                    this.formData.activities.push(item);
                                }
                            })
                        }else{
                            this.$message.error(msg || '没有找到相关演出');
                        }
                    }).catch(() => {
                        this.$message.error('系统错误');
                    }).finally(() => {
                        this.dataLoading = false;
                    });
            }
        },
        //删除演出
        delActivity(v){
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.formData.activities =this.formData.activities.filter( item => item !== v);
            }).catch(() => {})
        },  
    
  
    }
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
 margin-bottom: -25px;
}
.floatR{
 float: right;
}

</style>